// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProductReport":"eo_a bhs_a bhs_x bhs_j bhs_u bhs_bc bhs_ql bhs_vv"};